<template>
  <div class="loading">
     <div></div>
  </div>
</template>

<script>
   export default {
      name: "loading"
   }
</script>

<style scoped>
   @keyframes loading {
      0% {
         -webkit-transform: translate(-50%, -50%) rotate(0deg);
         transform: translate(-50%, -50%) rotate(0deg);
      }
      100% {
         -webkit-transform: translate(-50%, -50%) rotate(360deg);
         transform: translate(-50%, -50%) rotate(360deg);
      }
   }

   @-webkit-keyframes loading {
   0% {
      -webkit-transform: translate(-50%, -50%) rotate(0deg);
      transform: translate(-50%, -50%) rotate(0deg);
   }
   100% {
      -webkit-transform: translate(-50%, -50%) rotate(360deg);
      transform: translate(-50%, -50%) rotate(360deg);
      }
   }
   
   .loading {
      position: relative;
      width: 100%;
      height: 100%;
   }

   .loading div,
      .loading div:after {
      position: absolute;
      width: 160px;
      height: 160px;
      border: 20px solid #408520;
      border-top-color: transparent;
      border-radius: 50%;
   }

   .loading div {
      -webkit-animation: loading 1s linear infinite;
      animation: loading 1s linear infinite;
      top: 100px;
      left: 100px;
   }

   .loading div:after {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
   }

   .loading {
      width: 151px !important;
      height: 151px !important;
      -webkit-transform: translate(-75.5px, -75.5px) scale(0.755) translate(75.5px, 75.5px);
      transform: translate(-75.5px, -75.5px) scale(0.755) translate(75.5px, 75.5px);
   }
</style>





// WEBPACK FOOTER //
// resources/assets/js/components/Loading/Loading.vue